import { render, staticRenderFns } from "./LegalMinimumWageValidationResultTable.vue?vue&type=template&id=2db5ec02&scoped=true"
import script from "./LegalMinimumWageValidationResultTable.vue?vue&type=script&lang=js"
export * from "./LegalMinimumWageValidationResultTable.vue?vue&type=script&lang=js"
import style0 from "./LegalMinimumWageValidationResultTable.vue?vue&type=style&index=0&id=2db5ec02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5ec02",
  null
  
)

export default component.exports